module.exports = "<div class=modal-header> <h3 class=modal-title>Import a File</h3> </div> <div class=modal-body> <p>YAML or JSON formats are accepted</p> <input on-read-file=fileChanged($fileContent) type=file ng-model=file> <p class=invalid ng-if=isInvalidFile()>Invalid File. Please use YAML or JSON.</p> </div> <div class=modal-footer> <button class=\"btn btn-warning\" ng-click=cancel()>Cancel</button> <button class=\"btn btn-primary\" ng-click=ok() ng-disabled=\"isInvalidFile() || !isFileSelected()\">Import</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/file-import.html
// module id = 393
// module chunks = 0